import React from "react";
import "./UaeService.css";
import UaeServiceHead from "./UaeServiceHead";
import UaeServiceMain from "./UaeServiceMain";

const UaeService = () => {
  return (
    <div className="uaeServiceContainer">
      <UaeServiceHead head="UAE Attestation Services in Bangalore"/>
      <UaeServiceMain/>
    </div>
  );
};

export default UaeService;
